import Autocomplete from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { useIsFetching } from '@tanstack/react-query'
import { useRejectedMessagesView } from 'context/RejectedMessagesViewContext'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const RejectedMessagesFilters = (): ReactElement => {
  const { t } = useTranslation()
  const { filters, filtersDirty, setFilters, resetFilters } = useRejectedMessagesView()
  const isFetching = useIsFetching({ queryKey: ['rejected-messages'] })

  return (
    <Box sx={{ position: 'relative' }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={filters.keywords ?? []}
            onChange={(event, newValue): void => {
              setFilters({
                keywords: newValue,
              })
            }}
            renderValue={(tagValue, getTagProps): ReactElement[] =>
              tagValue.map((option, index) => (
                // eslint-disable-next-line react/jsx-key
                <Chip {...getTagProps({ index })} variant="outlined" size="small" label={option} />
              ))
            }
            renderInput={(params): ReactElement => (
              <TextField {...params} label={t('screens.cs.message_manager.filters.search')} />
            )}
            disabled={isFetching > 0}
          />
        </Grid>
      </Grid>
      {filtersDirty && (
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={resetFilters}
          sx={{
            padding: 0,
            minHeight: 'auto',
          }}
        >
          {t('general.reset_filters')}
        </Button>
      )}
    </Box>
  )
}

export default RejectedMessagesFilters
